const OrderAPI = {
  applyVoucher (order_total, shipping_total, barangay_code, merchant_orders,  voucher_code, login_id) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/apply_voucher.php', {
        method: 'POST',
        body: JSON.stringify({ 
          'order_total': order_total,
          'shipping_total': shipping_total,
          'barangay_code': barangay_code,
          'merchant_orders': merchant_orders,
          'voucher_code': voucher_code,
          'login_id': login_id })
      })
		    .then(response => response.json())
		    resolve(response)
    })
  },
  getOrderDiscount (province_code, city_code, barangay_code, products, login_id, voucher_code) {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/cart_discount.php', {
        method: 'POST',
        body: JSON.stringify({ 
          'province_code': province_code,
          'city_code': city_code,
          'barangay_code': barangay_code,
          'data': products,
          'login_id': login_id  ,
          'voucher_code': voucher_code})
      })
        .then(response => response.json())
        resolve(response)
    })
  },
  submitOrder(order)
  {
     return new Promise((resolve, reject) => {
      const response = fetch('/static/api/submit_order.php', {
        method: 'POST',
        body: JSON.stringify({ 
          'order': order })
      })
        .then(response => response.json())
        resolve(response)
    })
  },
  trackOrder(email_address, order_id)
  {
     return new Promise((resolve, reject) => {
      const response = fetch('/static/api/track_order.php', {
        method: 'POST',
        body: JSON.stringify({ 
          'order_id': order_id,
          'email_address': email_address })
      })
        .then(response => response.json())
        resolve(response)
    })
  },
}
export default OrderAPI



// WEBPACK FOOTER //
// ./src/api/order.js